import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';

const RegistrarContratos = () => {
  const { id: instructorId, idcontrato } = useParams();
  const navigate = useNavigate();
  const edit = !!idcontrato;

  const [contrato, setContrato] = useState('');
  const [rp, setRp] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [valorContrato, setValorContrato] = useState('');
  const [numeroCuenta, setNumeroCuenta] = useState('');
  const [tipoCuenta, setTipoCuenta] = useState('');
  const [banco, setBanco] = useState('');
  const [municipioSede, setMunicipioSede] = useState('');
  const [estado, setEstado] = useState('');
  const [regionales, setRegionales] = useState([]);
  const [regional, setRegional] = useState('');
  const [centros, setCentros] = useState([]);
  const [centroFormacion, setCentroFormacion] = useState('');
  const [objetoContrato, setObjetoContrato] = useState('');
  const [valorFormaPago, setValorFormaPago] = useState('');

  const [supervisor, setSupervisor] = useState({
    documento: '',
    nombre: '',
    cargo: ''
  });

  const [subdirector, setSubdirector] = useState({
    documento: '',
    nombre: '',
    cargo: ''
  });

  useEffect(() => {
    const getData = async () => {
      try {
        const { data } = await axios.get(`/api/contratos/listid/${idcontrato}`);
        const contrato = data.contrato;

        setContrato(contrato.contrato || '');
        setRp(contrato.rp || '');
        setFechaInicio(contrato.fechaInicio?.substring(0, 10) || '');
        setFechaFin(contrato.fechaFin?.substring(0, 10) || '');
        setValorContrato(contrato.valorContrato || '');
        setNumeroCuenta(contrato.numeroCuenta || '');
        setTipoCuenta(contrato.tipoCuenta || '');
        setBanco(contrato.banco || '');
        setMunicipioSede(contrato.municipioSede || '');
        setEstado(contrato.estado || '');
        setRegional(contrato.regional || '');
        setCentroFormacion(contrato.centroFormacion || '');
        setObjetoContrato(contrato.objetoContrato || '');
        setValorFormaPago(contrato.valorFormaPago || '');
        setSupervisor(contrato.supervisor || { documento: '', nombre: '', cargo: '' });
        setSubdirector(contrato.subdirector || { documento: '', nombre: '', cargo: '' });
      } catch (error) {
        console.error('Error al cargar el contrato:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error al cargar contrato',
          text: error.response?.data?.message || 'Error inesperado al cargar datos.',
        });
      }
    };

    if (idcontrato) {
      getData();
    }
  }, [idcontrato]);

  useEffect(() => {
    const fetchRegionales = async () => {
      try {
        const res = await axios.get('/api/regionales/listall');
        if (res.data.ok) {
          const regionalesOrdenadas = res.data.regionales.sort((a, b) =>
            a.nombreRegional.localeCompare(b.nombreRegional)
          );
          setRegionales(regionalesOrdenadas);
        }
      } catch (error) {
        console.error('Error al obtener las regionales:', error);
      }
    };

    fetchRegionales();
  }, []);

  useEffect(() => {
    const fetchCentros = async () => {
      if (!regional) return;

      try {
        const res = await axios.get(`/api/centrosdeformacion/listxregional/${regional}`);
        if (res.data.ok) {
          setCentros(res.data.regional.centros);
        }
      } catch (error) {
        console.error('Error al obtener centros:', error);
      }
    };

    fetchCentros();
  }, [regional]);

  const saveContrato = async () => {
    try {
      const newContrato = {
        contrato,
        rp,
        fechaInicio,
        fechaFin,
        valorContrato,
        numeroCuenta,
        tipoCuenta,
        banco,
        municipioSede,
        estado,
        regional,
        centroFormacion,
        supervisor,
        subdirector,
        objetoContrato,
        valorFormaPago,
        instructor: instructorId
      };

      await axios.post('/api/contratos/add', newContrato);

      // Limpieza de campos
      setContrato('');
      setRp('');
      setFechaInicio('');
      setFechaFin('');
      setValorContrato('');
      setNumeroCuenta('');
      setTipoCuenta('');
      setBanco('');
      setMunicipioSede('');
      setEstado('');
      setRegional('');
      setCentroFormacion('');
      setSupervisor('');
      setSubdirector('');
      setObjetoContrato('');
      setValorFormaPago('');

      Swal.fire({
        icon: 'success',
        title: '¡Contrato registrado con éxito!',
        showConfirmButton: false,
        timer: 1500,
      });

      navigate('/instructor/listarinstructores');

    } catch (error) {
      console.error('Error en saveContrato:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Error al guardar el contrato.',
      });
    }
  };

  const updateContrato = async () => {
    try {
      const contratoActualizado = {
        contrato,
        rp,
        fechaInicio,
        fechaFin,
        valorContrato,
        numeroCuenta,
        tipoCuenta,
        banco,
        municipioSede,
        estado,
        regional,
        centroFormacion,
        supervisor,
        subdirector,
        objetoContrato,
        valorFormaPago
      };

      await axios.put(`/api/contratos/update/${idcontrato}`, contratoActualizado);

      Swal.fire({
        icon: 'success',
        title: '¡Contrato actualizado con éxito!',
        showConfirmButton: false,
        timer: 1500,
      });

      navigate(-1);

    } catch (error) {
      console.error('Error al actualizar contrato:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error al actualizar',
        text: error.response?.data?.message || 'Error inesperado',
      });
    }
  };

  const actions = async (e) => {
    e.preventDefault();
    edit ? await updateContrato() : await saveContrato();
  };

  const [activeTab, setActiveTab] = useState('tab1');

  return (
    <div className="container-fluid py-5 px-5 shadow-lg rounded-4 bg-light mt-5 mb-5">
      <div className="container-fluid">
        <h1>Registrar Contrato</h1>

        {/* Navegación por pestañas */}
        <ul className="nav nav-tabs mt-4">
          <li className="nav-item">
            <button className={`nav-link ${activeTab === 'tab1' ? 'active' : ''}`} onClick={() => setActiveTab('tab1')}>
              Información del Contrato
            </button>
          </li>
          <li className="nav-item">
            <button className={`nav-link ${activeTab === 'tab2' ? 'active' : ''}`} onClick={() => setActiveTab('tab2')}>
              Supervisor y Subdirector(a)
            </button>
          </li>
          <li className="nav-item">
            <button className={`nav-link ${activeTab === 'tab3' ? 'active' : ''}`} onClick={() => setActiveTab('tab3')}>
              Información Adicional
            </button>
          </li>

        </ul>

        <form onSubmit={actions}>
          <div className="container">
            {/* Pestaña 1: Información del Contrato */}
            {activeTab === 'tab1' && (
              <div className="row">
                <div className="col-md-2">
                  <label className="form-label mt-3 mb-2">Contrato</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: 001-2025"
                    value={contrato}
                    onChange={(e) => setContrato(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label mt-3 mb-2">RP</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: 001-2025"
                    value={rp}
                    onChange={(e) => setRp(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label mt-3 mb-2">Fecha de Inicio</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fechaInicio}
                    onChange={(e) => setFechaInicio(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-2">
                  <label className="form-label mt-3 mb-2">Fecha de Finalización</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fechaFin}
                    onChange={(e) => setFechaFin(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label mt-3 mb-2">Valor del Contrato ($)</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Ej: 15000000"
                    value={valorContrato}
                    onChange={(e) => setValorContrato(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label mt-3 mb-2">Número de Cuenta</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: 1234567890"
                    value={numeroCuenta}
                    onChange={(e) => setNumeroCuenta(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label mt-3 mb-2">Tipo de Cuenta</label>
                  <select
                    className="form-control"
                    value={tipoCuenta}
                    onChange={(e) => setTipoCuenta(e.target.value)}
                    required
                  >
                    <option value="">Seleccione tipo</option>
                    <option value="Ahorros">Ahorros</option>
                    <option value="Corriente">Corriente</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>

                <div className="col-md-3">
                  <label className="form-label mt-3 mb-2">Banco</label>
                  <select
                    className="form-control"
                    value={banco}
                    onChange={(e) => setBanco(e.target.value)}
                    required
                  >
                    <option value="" disabled>Seleccione un banco</option>
                    <option value="Bancolombia">Bancolombia</option>
                    <option value="Banco de Bogotá">Banco de Bogotá</option>
                    <option value="Banco Davivienda">Banco Davivienda</option>
                    <option value="Banco de Occidente">Banco de Occidente</option>
                    <option value="Banco AV Villas">Banco AV Villas</option>
                    <option value="Banco Agrario">Banco Agrario</option>
                    <option value="Banco Popular">Banco Popular</option>
                    <option value="Banco Itaú">Banco Itaú</option>
                    <option value="Banco BBVA">Banco BBVA</option>
                    <option value="Banco Falabella">Banco Falabella</option>
                    <option value="Banco Pichincha">Banco Pichincha</option>
                    <option value="Banco Finandina">Banco Finandina</option>
                    <option value="Banco Caja Social">Banco Caja Social</option>
                    <option value="Banco GNB Sudameris">Banco GNB Sudameris</option>
                    <option value="Banco Coopcentral">Banco Coopcentral</option>
                    <option value="Banco Serfinanza">Banco Serfinanza</option>
                    <option value="Nequi">Nequi</option>
                    <option value="Daviplata">Daviplata</option>
                    <option value="Movii">Movii</option>
                    <option value="Lulo Bank">Lulo Bank</option>
                    <option value="Nu Colombia">Nu Colombia</option>
                    <option value="RappiPay">RappiPay</option>
                    <option value="Banco W">Banco W</option>
                    <option value="Banco Mundo Mujer">Banco Mundo Mujer</option>
                    <option value="Scotiabank Colpatria">Scotiabank Colpatria</option>
                  </select>
                </div>

                 <div className="col-md-3">
                  <label className="form-label mt-3 mb-2">Municipio Sede</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: Medellin"
                    value={municipioSede}
                    onChange={(e) => setMunicipioSede(e.target.value)}
                    required
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label mt-3 mb-2">Estado</label>
                  <select
                    className="form-control"
                    value={estado}
                    onChange={(e) => setEstado(e.target.value)}
                    required
                  >
                    <option value="">Seleccione estado</option>
                    <option value="Activo">Activo</option>
                    <option value="Finalizado">Finalizado</option>
                    <option value="Suspendido">Suspendido</option>
                  </select>
                </div>

                <div className="col-md-3">
                  <label className="form-label mt-3 mb-2">Regional</label>
                  <select
                    className="form-select"
                    value={regional}
                    onChange={(e) => setRegional(e.target.value)}
                    required
                  >
                    <option value="">Seleccione una regional</option>
                    {regionales.map((reg) => (
                      <option key={reg._id} value={reg._id}>
                        {reg.nombreRegional}
                      </option>
                    ))}
                  </select>
                </div>


                <div className="col-md-6">
                  <label className="form-label mt-3 mb-2">Centro de Formación</label>
                  <select
                    className="form-select"
                    value={centroFormacion}
                    onChange={(e) => setCentroFormacion(e.target.value)}
                    required
                  >
                    <option value="">Seleccione un centro</option>
                    {centros.map((centro) => (
                      <option key={centro._id} value={centro._id}>
                        {centro.nombreCentro}
                      </option>
                    ))}
                  </select>
                </div>

              </div>

            )}

            {/* Pestaña 2: Supervisor y Subdirector */}
            {activeTab === 'tab2' && (
              <div className="row">
                <div className="col-12 mt-3">
                  <h5 className="fw-bold">Información del Supervisor del Contrato</h5>
                </div>

                <div className="col-md-3">
                  <label className="form-label mt-3 mb-2">Documento</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: 1234567890"
                    value={supervisor.documento}
                    onChange={(e) => setSupervisor({ ...supervisor, documento: e.target.value })}
                    required
                  />
                </div>

                <div className="col-md-5">
                  <label className="form-label mt-3 mb-2">Nombre Completo</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: Juan Pérez"
                    value={supervisor.nombre}
                    onChange={(e) => setSupervisor({ ...supervisor, nombre: e.target.value })}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label mt-3 mb-2">Cargo</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: Coordinador Regional"
                    value={supervisor.cargo}
                    onChange={(e) => setSupervisor({ ...supervisor, cargo: e.target.value })}
                    required
                  />
                </div>

                <div className="col-12 mt-4">
                  <h5 className="fw-bold">Información del Subdirector(a) Encargado(a) (E)</h5>
                </div>

                <div className="col-md-3">
                  <label className="form-label mt-3 mb-2">Documento</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: 9876543210"
                    value={subdirector.documento}
                    onChange={(e) => setSubdirector({ ...subdirector, documento: e.target.value })}
                    required
                  />
                </div>

                <div className="col-md-5">
                  <label className="form-label mt-3 mb-2">Nombre Completo</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: María Gómez"
                    value={subdirector.nombre}
                    onChange={(e) => setSubdirector({ ...subdirector, nombre: e.target.value })}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label mt-3 mb-2">Cargo</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: Subdirectora Encargada"
                    value={subdirector.cargo}
                    onChange={(e) => setSubdirector({ ...subdirector, cargo: e.target.value })}
                    required
                  />
                </div>
              </div>

            )}

            {/* Pestaña 3: Información adicional */}
            {activeTab === 'tab3' && (
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label mt-3 mb-2">Objeto del Contrato</label>
                  <textarea
                    className="form-control"
                    placeholder="Descripción del objeto"
                    rows="3"
                    value={objetoContrato}
                    onChange={(e) => setObjetoContrato(e.target.value)}
                    required
                  ></textarea>
                </div>

                <div className="col-md-12">
                  <label className="form-label mt-3 mb-2">Valor y Forma de Pago</label>
                  <textarea
                    className="form-control"
                    placeholder="Descripción del pago"
                    rows="3"
                    value={valorFormaPago}
                    onChange={(e) => setValorFormaPago(e.target.value)}
                    required
                  ></textarea>
                </div>
              </div>
            )}
          </div>

          <div className="row mt-5 mb-3">
            <div className="col-md-6 mt-4">
              <button type="submit" className="btn btn-success w-100">
                {edit ? 'Actualizar Contrato' : 'Registrar Contrato'}
              </button>
            </div>

            <div className="col-md-6 mt-4">
              <button
                type="button"
                className="btn btn-danger w-100"
                onClick={() => navigate(-1)}
              >
                Cancelar
              </button>
            </div>
          </div>

        </form>
      </div>
    </div>
  );
};

export default RegistrarContratos;
